import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Enrollment } from '../../models/enrollment.model';

@Component({
  selector: 'app-enrollment-summary-card',
  templateUrl: './enrollment-summary-card.component.html',
  styleUrls: ['./enrollment-summary-card.component.scss']
})
export class EnrollmentSummaryCardComponent {

    @Input() enrollment: Enrollment;

    constructor(private router: Router) { }

    ngOnInit() { }

    public goToDetail(enrollmentCode: string) {

        var url = `inscripcion/${enrollmentCode}/info`;
        this.router.navigate([url]);

    }

}
